import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bus-tracking" }
const _hoisted_2 = { class: "md:flex gap-4" }
const _hoisted_3 = { class: "md:w-3/4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "flex items-center gap-3 mb-1" }
const _hoisted_6 = { class: "text-grey text-base font-normal" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-red font-normal text-sm italic" }, "*data lokasi yang ditampilkan tidak realtime", -1)
const _hoisted_8 = {
  id: "mapDiv",
  ref: "mapDiv",
  class: "mapDiv mb-5 pt-5",
  style: {"height":"80vh","width":"100%","overflow":"auto"}
}
const _hoisted_9 = { class: "md:w-1/4" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "flex items-center gap-2 mt-3" }
const _hoisted_12 = { class: "text-grey text-base font-semibold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
const _hoisted_14 = {
  class: "overflow-y-scroll",
  style: {"height":"80vh"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "2xl:flex items-center justify-between gap-3 pb-3 mb-3 border-bottom-grey-4" }
const _hoisted_17 = { class: "text-xl font-extrabold" }
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = { class: "text-grey text-xs font-bold" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-xs font-bold" }, "-", -1)
const _hoisted_21 = { class: "text-green text-xs font-bold" }
const _hoisted_22 = { class: "text-2xl font-extrabold text-primary break-all" }
const _hoisted_23 = { class: "2xl:grid grid-cols-3 gap-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-seibold text-grey" }, "Lokasi Terakhir", -1)
const _hoisted_25 = { class: "text-sm font-bold break-all" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-semibold text-grey" }, "Kondektur", -1)
const _hoisted_27 = { class: "text-sm font-bold break-all" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-semibold text-grey" }, "Sopir", -1)
const _hoisted_29 = { class: "text-sm font-bold break-all" }

import Card from 'primevue/card'
import { Loader } from '@googlemaps/js-api-loader'
import { getCurrentInstance, onMounted, ref, toRefs } from 'vue'
import $ from 'jquery'
import apiUseCase from '@/usecase/apiUseCase'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import moment from 'moment'
import Popper from 'vue3-popper'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const endpoint = 'transaction/v1/Dashboard/BusDashboardIncome'
const placeholder = 'Cari Disini...'

const GOOGLE_MAPS_API_KEY = 'AIzaSyBeIU_SpMpwm43tEK-y0XvWCZtPFwxFzsQ'
let map = null as any
const loader = new Loader({
  apiKey: GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['places']
})
const selectedVehicleId = ref(null) as any
const dataSourceDefault = ref([]) as any
const dataSource = ref([]) as any
const app = getCurrentInstance()
const {
  $icon
} = app!.appContext.config.globalProperties
const inputSearch = ref('')
const icon = $icon
const lastUpdate = ref(moment())

const dataDummy = ref([
  {
    id: 0,
    position: { lat: -7.266275, lng: 112.744873 },
    nopol: 'A 111 AAA ',
    driver: 'Driver 1',
    condectur: 'Condectur 1',
    lastLocation: 'City 1',
    passenger: 100,
    hullNumber: 'HJ-0001',
    amount: 50000
  },
  {
    id: 1,
    position: { lat: -7.531303, lng: 112.609740 },
    nopol: 'A 222 AAA',
    driver: 'Driver 2',
    condectur: 'Condectur 2',
    lastLocation: 'City 2',
    passenger: 50,
    hullNumber: 'HJ-0002',
    amount: 25000
  },
  {
    id: 2,
    position: { lat: -6.995878, lng: 110.353429 },
    nopol: 'A 333 AAA',
    driver: 'Driver 3',
    condectur: 'Condectur 3',
    lastLocation: 'City 3',
    passenger: 75,
    hullNumber: 'HJ-0001',
    amount: 45000
  }
])

// eslint-disable-next-line no-undef
// const markers: google.maps.Marker[] = []
const markers = [] as any
// eslint-disable-next-line no-undef
// let map: google.maps.Map

const dataReturn = (data: any) => ({
  position: {
    lat: Number(data.Latitude),
    lng: Number(data.Longitude)
  },
  tempPosition: {
    lat: Number(data.Latitude),
    lng: Number(data.Longitude)
  },
  icon: require('@/assets/img/icon/bus-white-bg-red.svg'),
  // shape: shape,
  title: data.VehicleRegNumber,
  map,
  // animation: google.maps.Animation.DROP,
})

function addedMarker(data: any): void {
  // markers.push(
  //   // eslint-disable-next-line no-undef
  //   new google.maps.Marker(dataReturn(data))
  // )

  // eslint-disable-next-line no-undef
  // markers[data.id] = new google.maps.Marker(dataReturn(data))
  // eslint-disable-next-line no-undef
  const marker = new google.maps.Marker(dataReturn(data))
  markers[data.VehicleHullNumber] = marker
  // console.log('markers', markers)
  // eslint-disable-next-line no-use-before-define
  marker.addListener('click', () => highlightVehicle(data))
}

const initMap = async () => {
  loader.load().then(() => {
    // eslint-disable-next-line no-undef
    map = new google.maps.Map(document.getElementById('mapDiv') as HTMLElement, {
      center: {
        lat: -7.250806,
        lng: 109.686858
      },
      zoom: 7.2,
    })

    map.addListener('zoom_changed', () => {
      const currentZoomLevel = map.getZoom()

      if (currentZoomLevel < 15) {
        console.log('Zoom level is low, hiding some elements...')
        $(`.vehicle-${selectedVehicleId.value}`).toggleClass('active')
        selectedVehicleId.value = null
        // Contoh: Sembunyikan marker atau elemen tertentu
      } else {
        console.log(`${map.getZoom()}  Zoom level is sufficient, showing all elements...`)
        // Contoh: Tampilkan kembali marker atau elemen
      }
    })

    map.addListener('dragend', () => {
      // console.log('dragged')
      $(`.vehicle-${selectedVehicleId.value}`).removeClass('active')
      selectedVehicleId.value = null
    })

    for (let i = 0; i < dataSource.value.length; i++) {
      addedMarker(dataSource.value[i])
    }
  })
}

const highlightVehicle = (data: any) => {
  if (selectedVehicleId.value) {
    $(`.vehicle-${selectedVehicleId.value}`).removeClass('active')
    selectedVehicleId.value = null
  }
  selectedVehicleId.value = data.VehicleHullNumber
  // console.log('markers', markers)
  // console.log('data', data)
  const currVehicle = markers[data.VehicleHullNumber]
  // console.log('curVehicle', currVehicle)
  if (currVehicle) {
    map.setCenter(currVehicle.getPosition())
    map.setZoom(15)

    // eslint-disable-next-line no-undef
    currVehicle.setAnimation(google.maps.Animation.BOUNCE)
    setTimeout(() => currVehicle.setAnimation(null), 2000)

    // console.log('x', $(`.vehicle-${data.id}`))
    $(`.vehicle-${data.VehicleHullNumber}`).addClass('active')
  }
}

const getAllData = async () => {
  await apiUseCase.get(`${endpoint}?pageSize=200`).then((response) => {
    // console.log('response', response)
    if (!response.error) {
      dataSourceDefault.value = response.result
      dataSource.value = response.result
      initMap()
    }
  })
}

const onSearch = () => {
  console.log('search', inputSearch.value)
  dataSource.value = []
  if (inputSearch.value === '') {
    dataSource.value = dataSourceDefault.value
  } else {
    // eslint-disable-next-line eqeqeq
    dataSource.value = dataSourceDefault.value.filter((x: any) => x.VehicleRegNumber.includes(inputSearch.value) || x.VehicleHullNumber.includes(inputSearch.value))
  }
  initMap()
}

const refreshPage = () => {
  lastUpdate.value = moment()
  getAllData()
}

onMounted(() => {
  getAllData()
  // initMap()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(`Update terakhir: ${lastUpdate.value.format('DD MMMM YYYY')}, ${lastUpdate.value.format('HH:mm')} WIB`), 1),
                _createVNode(_unref(Popper), {
                  arrow: "",
                  hover: "",
                  placement: "bottom",
                  content: "Refresh untuk memperbaruhi data"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: "pi pi-sync text-primary text-xs font-normal cursor-pointer",
                      onClick: refreshPage
                    })
                  ]),
                  _: 1
                })
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, "Tidak dapat menampilkan peta", 512)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(InputIconRight, {
                class: "input-search-header-custom",
                placeholder: placeholder,
                modelValue: inputSearch.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
                canClick: true,
                icon: _unref(icon).svg.searchEva,
                onSubmitInput: onSearch,
                onKeyup: _withKeys(onSearch, ["enter"])
              }, null, 8, ["modelValue", "icon", "onKeyup"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(`Total: ${_unref(dataSource).length} perangkat live`), 1),
                _createVNode(_unref(Popper), {
                  arrow: "",
                  hover: "",
                  content: "Total perangkat yang sedang aktif dijalankan di RIT 1 atau RIT 2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (data) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["p-3 vehicle-card rounded-lg mb-3 cursor-pointer", `vehicle-${String(data.VehicleHullNumber)}`]),
                  key: data,
                  onClick: ($event: any) => (highlightVehicle(data))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(data.VehicleRegNumber), 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(data.VehicleHullNumber), 1),
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, _toDisplayString(data.TotalTiketAmount) + " Penumpang", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(currencyNumberFormat)(data.TotalIncome)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", null, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, _toDisplayString(data.LastLocation), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, _toDisplayString(data.CondecturName ?? '-'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, _toDisplayString(data.DriverName ?? '-'), 1)
                      ])
                    ])
                  ])
                ], 10, _hoisted_15))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})